import AbstractScene from './AbstractScene.js';
import UI from './UI.js';

export default class Preloader extends AbstractScene {

    constructor() {
        super({
            key: "Preloader"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();

        // Ajout du texte de chargement
        this.loadingText = this.make.text({
            x: this.width / 2,
            y: this.height / 2,
            text: 'Chargement... 0%',
            style: {
                font: '60px CardenioBold',
                fill: '#000000',
                stroke: '#FFF',
                strokeThickness: 8
            }
        });

        this.loadingText.setOrigin(0.5, 0.5);

        this.loadSprites();

        this.load.on('progress', (value) => {
            // this.chargement.setScale(value, 1);
            this.loadingText.text = 'Chargement... ' + Math.floor(value * 100) + '%';
        });

        // this.load.on('fileprogress', function (file) {
        // console.log(file.src);
        // });

        this.load.on('complete', function () {
            // this.scene.add('UI', UI, true);
            this.nextScene();
        }, this);
    }

    loadSprites() {
        // activité 1
        this.load.image('act1Background', 'assets/images/activite1/background.png');
        this.load.image('act1BouteilleMessage', 'assets/images/activite1/bouteille_message.png');
        this.load.image('act1MissionCartouche', 'assets/images/activite1/mission-cartouche.png');

        // activité 2
        this.load.image('act2Background', 'assets/images/activite2/background.png');
        this.load.image('act2BouteilleMessage', 'assets/images/activite2/bouteille_message.png');
        this.load.image('act2MissionCartouche', 'assets/images/activite2/mission-cartouche.png');

        // activité 3
        this.load.image('act3Background', 'assets/images/activite3/background.png');
        this.load.image('act3BouteilleMessage', 'assets/images/activite3/bouteille_message.png');
        this.load.image('act3MissionCartouche', 'assets/images/activite3/mission-cartouche.png');

        // activité 4
        this.load.image('act4Background', 'assets/images/activite4/background.png');
        this.load.image('act4BouteilleMessage', 'assets/images/activite4/bouteille_message.png');
        this.load.image('act4MissionCartouche', 'assets/images/activite4/mission-cartouche.png');

        // Communs
        this.load.image('ctaMenu', 'assets/images/commun/cta-menu.png');
        this.load.image('darkArrow', 'assets/images/commun/dark-arrow.png');
        this.load.image('exclamationIcon', 'assets/images/commun/exclamation-icon.png');
        this.load.image('lightArrow', 'assets/images/commun/light-arrow.png');
        this.load.image('logoNovotelWwf', 'assets/images/commun/logo-novotel-wwf.png');
        this.load.image('questionIcon', 'assets/images/commun/question-icon.png');
        this.load.image('closeBtn', 'assets/images/commun/close-btn.png');

        // Controls
        this.load.image('audioPlay', 'assets/images/controles/audio-play.png');
        this.load.image('audioWave', 'assets/images/controles/audio-wave.png');   
        this.load.image('videoBack', 'assets/images/controles/video-back.png');
        this.load.image('videoNext', 'assets/images/controles/video-next.png');
        this.load.image('videoPlay', 'assets/images/controles/video-play.png');

        // End
        this.load.image('endBackgroundCredits', 'assets/images/end/background-credits.png');
        this.load.image('endBackground', 'assets/images/end/background.png');

        // Intro
        this.load.image('introBackground', 'assets/images/intro/background.png');
        this.load.image('ctaDebutant', 'assets/images/intro/cta-debutant.png');
        this.load.image('ctaExpert', 'assets/images/intro/cta-expert.png');
        this.load.image('introTitleCart', 'assets/images/intro/title-cartouche.png');
        this.load.image('introTitle', 'assets/images/intro/title.png');
        this.load.image('ellipse', 'assets/images/intro/ellipse.png');

        // Audios
        this.load.audio('audioBateau', 'assets/audios/audio-bateau.wav');
        this.load.audio('audioFull', 'assets/audios/audio-full.mp3');
        this.load.audio('audioPlage', 'assets/audios/audio-plage.wav');
        this.load.audio('audioTravaux', 'assets/audios/audio-travaux.wav');
        this.load.audio('audioSonar', 'assets/audios/audio-sonar.wav');

        // Vidéos
        this.load.video('videoChaineAlimentaire', 'assets/videos/chaine-alimentaire.mp4');
        this.load.video('videoCrabeBleu', 'assets/videos/crabe-bleu.mp4');
        this.load.video('videoGenerique', 'assets/videos/generique.mp4');
        this.load.video('videoIntro', 'assets/videos/intro.mp4');
        this.load.video('videoOutro', 'assets/videos/outro.mp4');
        this.load.video('videoPosidonie', 'assets/videos/posidonie.mp4');
        this.load.video('videoRorqual', 'assets/videos/rorqual.mp4');

    }
}